'use strict'

angular.module('rmGroups')
    .config(['$stateProvider', function ($stateProvider) {

        let userCreateStateCreate = {
            url: '/new-user',
            views: {
                'usersdetail@': {

                    templateUrl: '/partial/app.partials.user.detail',
                    controller: 'UserFormCtrl',
                    controllerAs: 'ctrl'
                }
            },
            params: {
                fromOtherSource: true
            },
            onEnter: ['$state', 'bladesManager', function ($state, bladesManager) {
                var loadedViews = bladesManager.all()
                var found = loadedViews.some(function (el) {
                    return el.viewName === 'usersdetail'
                })
                let size = $state.includes('broadcast') ? 'one-third' : 'half'
                if (!found) {
                    bladesManager.insertRight({ viewName: 'usersdetail', size: size })
                }
            }],
            onExit: ['$state', '$stateParams', 'bladesManager', function ($state, $stateParams, bladesManager) {
                //ugly!
                if ($state.includes('groups.create')) {
                    bladesManager.removeRight('usersdetail')
                } else if ($state.includes('groups.update')) {
                    bladesManager.removeRight('usersdetail')
                }
            }]
        }
        let userCreateStateUpdate = angular.copy(userCreateStateCreate)

        $stateProvider
            .state('groups', {
                url: '/groups',

                views: {
                    'groups-overview': {
                        templateUrl: '/partial/app.partials.groups.overview',
                        controller: 'GroupOverviewCtrl',
                        controllerAs: 'GroupsCtrl',
                    },
                    'groups-detail': {

                        templateUrl: '/partial/app.panels.empty'
                    },
                },

                onEnter: ['bladesManager', (bladesManager) => {

                    bladesManager.clearAll()
                    bladesManager.insert({ viewName: 'groups-overview', size: 'half' })
                    bladesManager.insert({ viewName: 'groups-detail', size: 'half' })
                }],
            })
            .state('groups.create', {
                url: '/create',
                views: {

                    'groups-detail@': {

                        templateUrl: '/partial/app.partials.groups.detail',
                        controller: 'GroupsFormCtrl',
                        controllerAs: 'ctrl',
                    }
                }
            })
            .state('groups.update', {
                url: '/update/:id',
                views: {

                    'groups-detail@': {

                        templateUrl: '/partial/app.partials.groups.detail',
                        controller: 'GroupsFormCtrl',
                        controllerAs: 'ctrl',
                    }
                }
            })
            .state('groups.create.user', userCreateStateCreate)
            .state('groups.update.user', userCreateStateUpdate)
    }])
